import {
  TRIVIA_DEFAULT_TIMER_MS,
  TRIVIA_MAX_TIMER_S,
  TRIVIA_MIN_TIMER_S,
} from '../constants.ts';
import type { TriviaQuestionDraft } from './questionValidation.ts';

export type QuestionTimerMode = 'default' | 'custom';

export function isCustomQuestionTimer(
  timerMs: number | null | undefined,
): boolean {
  return typeof timerMs === 'number' && Number.isFinite(timerMs);
}

export function questionTimerMode(
  question: Pick<TriviaQuestionDraft, 'timerMs'>,
): QuestionTimerMode {
  return isCustomQuestionTimer(question.timerMs) ? 'custom' : 'default';
}

export function applyQuestionTimerMode<T extends TriviaQuestionDraft>(
  question: T,
  mode: QuestionTimerMode,
  defaultTimerMs: number,
): T {
  if (mode === 'default') {
    return { ...question, timerMs: null };
  }
  const current =
    typeof question.timerMs === 'number' && question.timerMs > 0
      ? question.timerMs
      : defaultTimerMs || TRIVIA_DEFAULT_TIMER_MS;
  return { ...question, timerMs: current };
}

export function applyCustomTimerSeconds<T extends TriviaQuestionDraft>(
  question: T,
  seconds: number,
): T {
  return { ...question, timerMs: seconds * 1000 };
}

export function timerSecondsForInput(
  question: Pick<TriviaQuestionDraft, 'timerMs'>,
  defaultTimerMs: number,
) {
  const ms =
    typeof question.timerMs === 'number' && question.timerMs > 0
      ? question.timerMs
      : defaultTimerMs || TRIVIA_DEFAULT_TIMER_MS;
  return Math.round(ms / 1000);
}

export function customTimerHint() {
  return `Custom: ${TRIVIA_MIN_TIMER_S} to ${TRIVIA_MAX_TIMER_S} seconds.`;
}
